var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1047 3.55519C15.3505 3.06061 15.9507 2.85892 16.4452 3.10471C19.7355 4.73984 22.0002 8.13688 22.0002 12.0647C22.0002 15.9925 19.7355 19.3896 16.4452 21.0247C15.9507 21.2705 15.3505 21.0688 15.1047 20.5742C14.8589 20.0796 15.0606 19.4795 15.5552 19.2337C18.1918 17.9234 20.0002 15.2043 20.0002 12.0647C20.0002 8.92508 18.1918 6.20601 15.5552 4.89574C15.0606 4.64995 14.8589 4.04977 15.1047 3.55519ZM6 8.06462H4C2.89543 8.06462 2 8.96005 2 10.0646V14.0646C2 15.1692 2.89543 16.0646 4 16.0646H6L10.3598 19.6978C11.0111 20.2406 12 19.7774 12 18.9296V5.19967C12 4.35183 11.0111 3.88867 10.3598 4.43144L6 8.06462ZM15.4 8.26495C15.8416 7.93326 16.4684 8.02235 16.8001 8.46393C17.5534 9.46681 18.0002 10.7149 18.0002 12.0645C18.0002 13.4141 17.5534 14.6622 16.8001 15.6651C16.4684 16.1067 15.8416 16.1958 15.4 15.8641C14.9584 15.5324 14.8693 14.9055 15.201 14.4639C15.7031 13.7955 16.0002 12.9661 16.0002 12.0645C16.0002 11.1629 15.7031 10.3335 15.201 9.66508C14.8693 9.2235 14.9584 8.59664 15.4 8.26495Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.f89309c2ee9438b0865c9ea14264de90.svg";
export { ForwardRef as ReactComponent };